export const LMS_COURSE_ID = {
  KIDS: 'QJhUDePfAn__Y6na',
  BASIC: 'Irmk2AAW2RWV-iHn',
  ADVANCED: 'XoaJAz_Vg6fJ1QxQ',
  WMW: 'VY6Yl4kxQsb3sYJZ',
  HFHJ: 'GXHrE6RAfYafHfgs',
} as const;

export const LMS_GUIDE_URL = {
  ASSIGNMENT_CREATE_JEBSON: 'https://cafe.naver.com/jemm/5134',
  ASSIGNMENT_CREATE_JEBSPL: 'https://cafe.naver.com/jcebs/26631',
  ASSIGNMENT_STATUS_JEBSON: 'https://cafe.naver.com/jemm/5135',
  ASSIGNMENT_STATUS_JEBSPL: 'https://cafe.naver.com/jcebs/26629',
  RECITATION_CREATE: 'https://cafe.naver.com/jemm/5131',
  RECITATION_STATUS: 'https://cafe.naver.com/jemm/5132',
  VOUCHER_MANAGEMENT_JEBSON: 'https://cafe.naver.com/jemm/5137',
  VOUCHER_MANAGEMENT_JEBSPL: 'https://cafe.naver.com/jcebs/26632',
  SIGNUP_MANAGEMENT_JEBSON: 'https://cafe.naver.com/jemm/5136',
  SIGNUP_MANAGEMENT_JEBSPL: 'https://cafe.naver.com/jcebs/26633',
} as const;

// 참고
// --------------------
// RECITATION = '(구)인증제',
// JEBS_AI_RECITATION = 'AI 인증제',
// JEBSON = '젭스온',
// JEBSPL = '젭스플',
// WMW = 'WMW',
// JS1 = 'JS1',
// JS2 = 'JS2',
// HF = 'HF',
// HJ = 'HJ',
// --------------------

export enum AssignmentType {
  RECITATION = 'RECITATION',
  JEBS_AI_RECITATION = 'JEBS_AI_RECITATION',
  EXAM = 'EXAM',
  JEBSON = 'JEBSON',
  JEBSPL = 'JEBSPL',
  SURVEY = 'SURVEY',
  // 젭스플 과목
  HF = 'HF',
  HJ = 'HJ',
  JS1 = 'JS1',
  JS2 = 'JS2',
  WMW = 'WMW',
  // 젭스온 과목 (JEBSON은 레거시 통합 타입, 아래 3개가 과목별 타입)
  EC = 'EC', // English Christian (잉크) — Book 1~4, 13~16, 25~28, 37~40
  EF = 'EF', // English Formula (잉포) — Book 5~8, 17~20, 29~32, 41~44
  ESB = 'ESB', // English Story Bible (잉스바) — Book 9~12, 21~24, 33~36, 45~48
  // 녹음 전용 과제 (암송 등)
  RECORDING = 'RECORDING',
}

export enum AssignmentStatusType {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  CLOSED = 'CLOSED',
  PROCESSING_RESULT = 'PROCESSING_RESULT',
}

export enum CourseId {
  BASIC = 'Irmk2AAW2RWV-iHn', // 영어교실 베이직
  HFHJ = 'GXHrE6RAfYafHfgs', // HFHJ
  WMW = 'VY6Yl4kxQsb3sYJZ', // WMW
}

export const SUBJECT_LABEL_MAP: Partial<Record<AssignmentType, string>> = {
  ESB: '잉스바',
  EF: '잉포',
  EC: '잉크',
  JEBS_AI_RECITATION: 'AI\n인증제',
  HF: 'HF',
  HJ: 'HJ',
  JS1: 'JS1',
  JS2: 'JS2',
  WMW: 'WMW',
};

export const SUBJECT_COLOR_MAP: Partial<Record<AssignmentType, string>> = {
  ESB: 'bg-[#FCE8EE] text-black text-sm border border-gray3',
  EF: 'bg-[#D8EFF9] text-black text-sm border border-gray3',
  EC: 'bg-[#FCFCE7] text-black text-sm border border-gray3',
  JEBS_AI_RECITATION: 'bg-[#FCFCE7] text-black text-xs border border-gray3',
  HF: 'bg-[#FCE8EE] text-black text-sm border border-gray3',
  HJ: 'bg-[#D8EFF9] text-black text-sm border border-gray3',
  JS1: 'bg-[#FCE8EE] text-black text-sm border border-gray3',
  JS2: 'bg-[#D8EFF9] text-black text-sm border border-gray3',
  WMW: 'bg-[#FCFCE7] text-black text-xs border border-gray3',
};

export const ASSIGNMENT_STATUS_LABEL_MAP: Record<AssignmentStatusType, string> =
  {
    [AssignmentStatusType.COMPLETED]: '완료',
    [AssignmentStatusType.IN_PROGRESS]: '진행 중',
    [AssignmentStatusType.NOT_STARTED]: '진행 전',
    [AssignmentStatusType.CLOSED]: '종료',
    [AssignmentStatusType.PROCESSING_RESULT]: '결과 처리 중',
  };
